import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './Screens/App'
import "./Screens/i18n";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);